<template>
  <NavBar />

  <div v-if="myWURFLData && myWURFLData.isMobile" class="w-full p-4 text-center bg-base-100 bg-purple-100">
      <p class="text-bold">We detected your {{ myWURFLData.completeDeviceName }} {{ myWURFLData.formFactor }}.</p>
  </div>

  <ErrorModal :msg="activeModalAlertMsg" :visible="showModal" />

  <div class="container mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
      <div class="p-4 col-span-1 flex items-start justify-center"> <!-- " sm:w-full md:w-1/2 lg:w-1/3 wf" -->
        <SelectBrandAndModel />
      </div>

      <div class="p-4 col-span-1 md:col-span-1 flex items-start justify-center"> <!-- " sm:w-full md:w-1/2 lg:w-3/12 wf" -->
        <div class="w-full">
          <DeviceList  :wurflData="myWURFLData" :collectDeviceInfo="showLinkToManualInfoCollect"/>
          <div class="divider"></div>
          <Choropleth v-if="selectedDevice" />
        </div>

      </div>

      <div class="p-4 col-span-1 md:col-span-2 xl:col-span-1 flex items-start justify-center"> <!-- " sm:w-full md:w-full lg:w-1/3 wf" -->
        <ShowSingleDevice />
      </div>
    </div>
  </div>

  <nav class="footer footer-center p-10 bg-primary text-primary-content">
    <div class="p-2">
      <b>Demo UI: WURFL Query</b> ({{myWURFLData.formFactor}} edition - {{myWURFLData.completeDeviceName}}) -
      This demo application illustrates the features of the <a class="underline" href="https://api.query.wurfl.io/" target="_blank">WURFL Query REST API.</a>
      <span class="small">2023 - ScientiaMobile, Inc. All rights reserved. WURFL&reg; is the registered trademark of ScientiaMobile, Inc.</span>
    </div>
    <div class="clear-both">
      <a href="https://www.scientiamobile.com/terms-and-conditions-privacy-licenses/">Terms, Privacy, &amp; Licenses</a>
    </div>
  </nav>
</template>

<script>
import NavBar from './components/NavBar.vue'
import ErrorModal from './components/ErrorModal.vue'
import SelectBrandAndModel from './components/SelectBrandAndModel.vue'
import DeviceList from './components/DeviceList.vue'
import Choropleth from './components/Choropleth.vue'
import ShowSingleDevice from './components/ShowSingleDevice.vue'

import axios from 'axios'
import Pusher from 'pusher-js'


import {useUiElements} from "./store/uiElements"
import { mapState, mapActions } from 'pinia'
// import { ref /* onUnmounted, inject */ } from "vue"

// let's add WURFL.js support programmatically
// console.log(new Date().getTime() - start, "loading WURFL.js from APP.vue component")
const wurfljs = document.createElement("script")
wurfljs.setAttribute(
  "src",
  "https://wjs.wurflcloud.com/wurfl.js?wurfl_id=true&debug=true"
)

document.head.appendChild(wurfljs)
console.dir("WURFL.js set script tag and attributes")

// // new dialog HTML TAG
// const openButton = document.querySelector(".open-btn");
// const closeButton = document.querySelector(".close-btn");
// const modal = document.querySelector(".modal");
// const dialog = document.querySelector("dialog");

// openButton.addEventListener("click", () => {
//   modal.showModal();
// });

// closeButton.addEventListener("click", () => {
//   modal.close();
// });

// dialog.addEventListener("click", e => {
//   const dialogDimensions = dialog.getBoundingClientRect();
//   if (
//   e.clientX < dialogDimensions.left ||
//   e.clientX > dialogDimensions.right ||
//   e.clientY < dialogDimensions.top ||
//   e.clientY > dialogDimensions.bottom)
//   {
//     dialog.close();
//   }
// });

export default {
  name: 'App',
  components: {
    NavBar,
    ErrorModal,
    SelectBrandAndModel,
    DeviceList,
    ShowSingleDevice,
    Choropleth
},

  data() {
    return {
      errorMsg: '',
      showError: false,
      showLinkToManualInfoCollect: false,
      myWURFLData: {}
      //Moved to uiElements.js:  baseUrl: process.env.VUE_APP_WURFLQUERY_URL || '',
    };
  },

  mounted() {

    // Let's include WURFL. Useful for several optimizations (including the QR code functionality)
    // formFactor is one of {Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile}
    // const myWURFLData = {} //ref({})
    // shall we add some quick and dirty form factor detection in the unlikely event WURFL.js
    // is unavailable? mmmm.... decisions, decisions. This should capture well north of 95% traffic
    this.myWURFLData.formFactor = ""
    this.myWURFLData.completeDeviceName = "Undefined"

    const userAgent = navigator.userAgent.toLowerCase()
    this.myWURFLData.isMobilePhone = /(ipod|phone|(android(.*)mobile))/.test(userAgent)
    this.myWURFLData.isTablet = /(ipad|tablet|(android(?!.*mobile))|kindle|playbook|silk)/.test(userAgent)
    this.myWURFLData.isSmartTV = /(googletv|sonydtv|appletv|apple tv|smarttv|smart-tv|dlna|inettvbrowser|opera tv|sony bravia|sonycebrowser|hbbtv|large screen|netcast|philipstv|digital-tv|vizio|bravia|roku|vudu|sony bd\/|sony dtv\/|tivo-device|vizio, d|tvos|samsung-agent\/|samsunghas-agent\/|model\/hisense|virginmedia_stb|firetv|android tv; ap|amazon_tv; ap|android tv\/|fire tv\/)/.test(userAgent)
    this.myWURFLData.isiOS = /(ipod|ipad|iphone|)/.test(userAgent)
    this.myWURFLData.isAndroid = /android/.test(userAgent)

    this.myWURFLData.isMobile = this.myWURFLData.isTablet || this.myWURFLData.isMobilePhone
    this.myWURFLData.isDesktop = !this.myWURFLData.isMobile
    if (this.myWURFLData.isMobilePhone) this.myWURFLData.formFactor = "Mobile Phone"
    if (this.myWURFLData.isTablet) this.myWURFLData.formFactor = "Tablet"
    if (this.myWURFLData.isDesktop) this.myWURFLData.formFactor = "Desktop"

    // console.dir("WURFL Promises here")
    // fill the this.myWURFLData object with data from WURFL.js
    window.addEventListener("WurflJSDetectionComplete", (e) => {
    // e.detail.WURFLPromises.complete.then(() => {
          console.log("WurflJSDetectionComplete TRIGGERED from App.vue for " + e.detail.WURFL.wurfl_id)
          this.myWURFLData.wurfl_id = e.detail.WURFL.wurfl_id
          // console.log("WURFL ID: ", e.detail.WURFL.wurfl_id)
          this.myWURFLData.formFactor = e.detail.WURFL.form_factor
          this.myWURFLData.isMobile = e.detail.WURFL.is_mobile
          this.myWURFLData.completeDeviceName = e.detail.WURFL.complete_device_name
          this.myWURFLData.isiOS = false
          if (e.detail.WURFL.advertised_device_os &&  e.detail.WURFL.advertised_device_os.includes("iOS")){
            this.myWURFLData.isiOS = true
          }
          this.myWURFLData.isAndroid = false
          if (e.detail.WURFL.advertised_device_os &&  e.detail.WURFL.advertised_device_os.includes("Android")){
            this.myWURFLData.isAndroid = true
          }

          this.myWURFLData.isDesktop = this.myWURFLData.formFactor === "Desktop"
          this.myWURFLData.isMobilePhone = ["Smartphone", "Feature Phone","Other Mobile"].indexOf(this.myWURFLData.formFactor)
  >= 0
          this.myWURFLData.isTablet = this.myWURFLData.formFactor === "Tablet"
          this.myWURFLData.isSmartTV = this.myWURFLData.formFactor === "Smart-TV"
          // console.dir(e)

          // and now something beautiful:
          // If page is Desktop, let's start listening for events that request that a specific device
          // is shown.
          // If page has been invoked with channel parameter (as a result od scanning the QR code),
          // let's notify channel of the device info that shouls be displayed.
          // The information is collected thru WURFL.js

          if (this.myWURFLData.isDesktop || this.myWURFLData.isTablet || this.myWURFLData.isSmartTV) {

            // Initialize Pusher
            const pusher = new Pusher(this.pusher_key, {
                cluster: this.pusher_cluster
            })

            // Subscribe to the channel
            const channel = pusher.subscribe(this.uniqueId)

            // Bind to the event and update the UI
            channel.bind('notification', data => {
                let wid = data.message // for testing: "generic_web_browser"
                console.log("PUSHER sent me this WURFL ID: ", wid)
                this.setCurrentDeviceThroughREST(wid)

                // if (wid && wid.indexOf("generic" != -1)) {
                //   this.setCurrentDeviceThroughREST(wid)
                // } else {
                //   this.setModalAlert("Device '" + wid +"' not recognized. Sorry")
                // }

            })
          }

          let urlParams = new URLSearchParams(window.location.search)
          if (urlParams.has('channel')) {
            console.log("Channel paramter: "+urlParams.get('channel'))
            let PushEndpoint = this.realBaseUrl + "/v1/devices/notify/" + urlParams.get('channel') + "?wurfl_id=" + this.myWURFLData.wurfl_id
            console.log(PushEndpoint)
            axios.get(PushEndpoint).catch((r) => {
              console.log(`Endpoint '${PushEndpoint}' failed for some reason: ${r}`)
            })
          }


          // if WURFL.js is giving us a match, the page has not been invoked to push to channel and
          // WURFL ID is  not generic, display the device info
          let wjs_wid = this.myWURFLData.wurfl_id
          if (wjs_wid && wjs_wid.indexOf("generic") == -1) {
            this.setCurrentDeviceThroughREST(wjs_wid)
          }

          if (wjs_wid && wjs_wid.indexOf("generic") != -1) {
            this.showLinkToManualInfoCollect = true
          }

          // I may need this later, as setting up routes for this single use-case seems overkill
          // let urlParams = new URLSearchParams(window.location.search);
          // console.log(urlParams.has('channel')); // true
          // console.log(urlParams.get('channel')); // "MyParam"

    })

  },

  computed: {
    ...mapState(useUiElements, {
        realBaseUrl: "realBaseUrl",
        uniqueId: "uniqueId",
        selectedDevice: "selectedDevice",
        activeModalAlertMsg: 'activeModalAlertMsg',
        showModal: 'showModal',
        variant: 'variant',
        pusher_key: 'pusher_key',
        pusher_cluster: 'pusher_cluster'
    })
  },

  methods: {
    ...mapActions(useUiElements, ['setModalAlert','setCurrentDevice','setCurrentDeviceThroughREST']),


  }
}
</script>

<!-- <style>
#app {

  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wf {
  outline: 1px solid black;
}


/*===========================
The juicy stuff
===========================*/
.open-btn,
.close-btn {
  border: none;
  cursor: pointer;
}

.open-btn {
  background-color: hsl(195, 53%, 79%);
  padding: 16px 32px;
  border-radius: 8px;
  transition: 350ms ease;
}

.open-btn:hover {
  background-color: hsl(195, 53%, 69%);
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  opacity: .8;
  transition: 350ms ease;
}

.close-btn:hover {
  opacity: 1;
  scale: 1.125;
}

dialog {
  height: 350px;
  width: 450px;
  margin: auto;
  padding: 1rem;
  text-align: center;
  background-color: rgb(17, 17, 17);
  border: solid;
  border-radius: 8px;
}

.modal::backdrop {
  background-color: rgba(17, 17, 17, 0.4);
}

.modal p {
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
}
</style> -->
